<div class="progress" [style.width]="value + '%'" [style.background-color]="color"></div>